import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import PERM from 'constants/core/perm.const';
import { useAccessIds, useCustomPermission } from 'providers/Access.provider';
import { selectAccessHasLockToken } from 'selectors/access.selectors';

const useIsPersonalCalendarOnly = () => {
  const hasLockToken = useSelector(selectAccessHasLockToken);
  const canViewAll = useCustomPermission(PERM.canViewCalendarAllStaff);
  const canViewPersonal = useCustomPermission(PERM.canViewCalendarPersonal);
  const { accessStylistId } = useAccessIds();

  return useMemo(
    () => ({
      isPersonalOnly: hasLockToken && canViewPersonal && !canViewAll && accessStylistId > 0,
      accessStylistId,
      hasLockToken,
      canViewAll,
      canViewPersonal,
    }),
    [hasLockToken, canViewAll, canViewPersonal, accessStylistId],
  );
};

export default useIsPersonalCalendarOnly;
